<template>
    <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">Organisation "{{ customer.name }}" editieren</h3>
                    </div>
                </div>
            </div>
            <template>
                <form @submit.prevent="editCustomer(customer.id)">
                    <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                    <h6 class="heading-small text-muted mb-4">Rechnungsanschrift für die Organisation</h6>
                    <div class="pl-lg-4">
                        <div class="row">
                            <div class="col-lg-5">
                                <base-input alternative=""
                                            required
                                            label="Firmenname"
                                            placeholder="Muster GmbH"
                                            input-classes="form-control-alternative"
                                            v-model="customer.name"
                                />
                            </div>
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            required
                                            label="Straße und Hausnummer"
                                            placeholder="Musterstraße 5"
                                            input-classes="form-control-alternative"
                                            v-model="customer.street"
                                />
                            </div>
                            <div v-if="$store.getters['authentication/isAdmin']" class="col-lg-1">
                                <base-input alternative=""
                                            required
                                            label="KNR"
                                            placeholder="K1000"
                                            input-classes="form-control-alternative"
                                            v-model="customer.fakturiaLogin"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            required
                                            label="Postleitzahl"
                                            placeholder="12345"
                                            input-classes="form-control-alternative"
                                            v-model="customer.postalcode"
                                />
                            </div>
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            required
                                            label="Stadt/Ort"
                                            placeholder="Musterstadt"
                                            input-classes="form-control-alternative"
                                            v-model="customer.city"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <label class="form-control-label">
                                    Land
                                    <span>*</span></label>
                                <select v-model="customer.country" class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                                    <option value="" disabled selected>Land</option>
                                    <option v-for="country in countries" :key="country.id" :value="country['@id']">{{ country.name }}</option>
                                </select>
                            </div>
                            <div class="col-lg-6">
                                <base-input alternative=""
                                            required
                                            label="USt.-Id:"
                                            placeholder="Umsatzsteuer Identifikationsnr"
                                            input-classes="form-control-alternative"
                                            v-model="customer.vatid"
                                />
                            </div>
                        </div>
                    </div>
                    <hr class="my-4" />
                    <!-- Address -->
                    <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                        <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                        <span class="btn-inner--text">Organisationsdaten ändern</span></button>
                </form>
            </template>
        </card>
</template>

<script>
    export default {
        name: "edit",
        data() {
            return {
                customer: {
                    id: 0,
                    name: "",
                    street: "",
                    postalcode: '',
                    city: "",
                    country: "",
                    vatid: ""
                },
                isLoading: false,
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        created() {
            if (!this.$store.getters['country/isReady']) this.$store.dispatch('country/getCountryCollection');
            this.showCustomer(this.$route.params.id)
        },
        computed: {
            countries () {
                return this.$store.getters['country/showCountryCollection'];
            },
        },
        methods: {
            showCustomer(id) {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/customers/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.customer = response;
                                this.customer.country = response.country['@id'];
                            },
                            error => {
                                this.isLoading = false;
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
            editCustomer(id) {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = this.customer;
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/customers/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.status =  {type: 'success', msg: 'Kunde '+response.name+' (ID: '+response.id+') wurden editiert.'};
                            },
                            error => {
                                this.isLoading = false;
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
        }
    }
</script>

<style scoped>

</style>